import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { CardCarousel } from '@iheartjane/menu';
import { Card, Flex, SparkleIcon, Typography } from '@iheartjane/reefer';
import type { IconComponent } from '@iheartjane/reefer';
import type { FC, ReactNode } from 'react';

import type { MenuRow } from '@jane/business-admin/types';

import { ListContainer } from './ListContainer';
import { HeaderToggle } from './ListItemHeaders';
import { CARD_HEIGHT, CARD_WIDTH, getRowLabel } from './utils';

import styles from './landing.module.css';

interface Props {
  afterHeader?: ReactNode;
  cardIcon?: FC;
  cardText: ReactNode;
  children?: ReactNode;
  row: MenuRow;
  rowHelperText?: ReactNode;
  wide?: boolean;
}

export const PreviewCardsListItem = ({
  afterHeader,
  cardIcon,
  cardText,
  children,
  row,
  rowHelperText,
  wide,
}: Props) => {
  const thematicRows = useFlag(FLAGS.comm3MultipleThematicRows);
  const rowLabel = getRowLabel(row, undefined, thematicRows);
  const Icon = cardIcon as IconComponent;

  return (
    <ListContainer rowEnabled>
      <CardCarousel
        beforeHeader={
          <HeaderToggle
            row={row}
            rowLabel={rowLabel}
            itemsLength={0}
            showProductsCTA={false}
            rowHelperText={rowHelperText}
          />
        }
        name={rowLabel}
        mode={wide ? 'fixed' : 'ideal-width'}
        cardWidth={wide ? 315 : CARD_WIDTH}
        cardHeight={wide ? 240 : CARD_HEIGHT}
        cardWidthMobile={212}
        cardHeightMobile={328}
        mb={40}
        hideCarouselControls
        afterHeader={afterHeader}
      >
        {Array.from({ length: wide ? 4 : 6 }).map((_, idx) => (
          <CardCarousel.Card key={idx}>
            <Card
              border="grays-light"
              width={wide ? 315 : '100%'}
              height={wide ? 240 : CARD_HEIGHT}
            >
              <Card.Content
                className={styles['cardContent']}
                background="grays-ultralight"
              >
                <Flex
                  background="grays-ultralight"
                  flexDirection="column"
                  alignItems="center"
                  height="100%"
                >
                  <Flex basis="55%" alignItems="center">
                    {cardIcon ? (
                      <Icon />
                    ) : (
                      <SparkleIcon
                        color={row.enabled ? 'primary' : 'grays-light'}
                      />
                    )}
                  </Flex>
                  <Flex
                    basis="45%"
                    alignItems="center"
                    justifyContent="center"
                    background="grays-white"
                    width="100%"
                  >
                    {typeof cardText === 'string' ? (
                      <Typography
                        color={row.enabled ? 'text-main' : 'grays-light'}
                      >
                        {cardText}
                      </Typography>
                    ) : (
                      cardText
                    )}
                  </Flex>
                </Flex>
              </Card.Content>
            </Card>
          </CardCarousel.Card>
        ))}
      </CardCarousel>
      {children}
    </ListContainer>
  );
};
